/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'safari': {
    width: 16,
    height: 16,
    viewBox: '0 0 126 126',
    data: '<path pid="0" d="M63 126C28.4 126 .3 97.9.3 63.3S28.4.7 63 .7s62.7 28.1 62.7 62.7S97.6 126 63 126zM63 4.9C30.8 4.9 4.6 31.1 4.6 63.3s26.2 58.4 58.4 58.4 58.4-26.2 58.4-58.4S95.2 4.9 63 4.9z"/><path pid="1" d="M63 8C32.4 8 7.6 32.8 7.6 63.3c0 30.6 24.8 55.4 55.4 55.4 30.6 0 55.4-24.8 55.4-55.4C118.4 32.8 93.6 8 63 8zM17.8 65.5H9.1v-4.2h8.7v4.2zM60.9 9.4h4.2v8.7h-4.2V9.4zm4.2 107.9h-4.2v-8.7h4.2v8.7zm11.4-40.6L24.1 94.1 51 50.4l51-17.9-25.5 44.2zm31.7-11.2v-4.2h8.7v4.2h-8.7z"/><path pid="2" d="M53.8 53.9l-20 32.5 39.8-13.3 19-32.8-38.8 13.6zm9.2 15c-3.1 0-5.5-2.5-5.5-5.5 0-3.1 2.5-5.5 5.5-5.5 3.1 0 5.5 2.5 5.5 5.5s-2.4 5.5-5.5 5.5z"/>'
  }
})
